/* lettra: Konfigurator — Funktionslogik 1:1 aus dem Prototyp
   (lettra_konfigurator.html): Preis pro Zeichen, Leerzeichen kostenlos,
   −10 % ab 10 Zeichen, Canvas-Breitenmessung, Platz-Planer.
   Preise kommen aus den Shopify-Varianten (Größe × Bereich);
   Fallback: Prototyp-Preisliste, solange das Produkt nicht angelegt ist.
   Motion laut DESIGN.md: Preis-Zähler 300ms, Rabattzeile 250ms,
   Font-/Farbwechsel 180ms Cross-Fade, Größenwechsel 250ms. */
(function () {
  'use strict';

  /* 25 cm ist gestrichen: Das Druckbett misst 256 mm, die Groessenangabe gilt
     fuer die Grossbuchstaben — das Bauteil ist immer groesser (runde Versalien
     +3 %, Umlaute +31 %). In den Slicer-Tests war 25 cm bei keiner Schrift
     vollstaendig herstellbar. */
  var SIZES = [5, 10, 15, 20];
  var FALLBACK_PRICES = {
    innen: { 5: 220, 10: 320, 15: 450, 20: 620 },
    aussen: { 5: 290, 10: 390, 15: 550, 20: 750 },
  };
  var AREAS = [
    { id: 'innen', label: 'Innenbereich', sub: 'Standard · bester Preis' },
    { id: 'aussen', label: 'Außenbereich', sub: 'Wetterfest (PETG)' },
  ];
  var COLORS = [
    { id: 'schwarz', label: 'Schwarz matt', chip: '#141414' },
    { id: 'weiss', label: 'Weiß', chip: '#fdfdfc' },
  ];
  var DEFAULT_TEXT = 'Familie Gruber';

  /* ---------- Zeichenvorrat ----------
     Muss der STL-Bibliothek entsprechen — Quelle ist
     ~/lettra-B2B/werkzeuge/zeichenvorrat.json, aus der auch der Generator und
     die Montagevorlage lesen; masse.csv listet dieselben Zeichen. Bei
     Erweiterung der Bibliothek hier nachziehen. Das Leerzeichen steht am
     Ende der Liste; es ist erlaubt und kostenlos, hat aber kein Bauteil. */
  var ERLAUBTE_ZEICHEN =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
    'abcdefghijklmnopqrstuvwxyz' +
    '0123456789' +
    'ÄÖÜäöüß' +
    /* Akzentbuchstaben, seit der STL-Bibliothek v3 (6. 8. 2026) in allen zehn
       Schriften vorhanden, in v4 unveraendert (per Glyphenpruefung gegen
       .notdef verifiziert).

       ç ist seit ~/lettra-stl-v4 (2. 9. 2026) in allen zehn Schriften
       vorhanden und geprueft: geslict mit "lettra Schriftzug filigran",
       wasserdicht, EIN zusammenhaengendes Teil (die Cedille haengt am c),
       keine Slicer-Warnung. In v3 fehlten die 40 Dateien — sie waren am
       6. 8. um 16:05 nach dem Lauf geloescht worden, masse.csv fuehrte sie
       weiter. Vom 1. bis 2. 9. war ç deshalb gesperrt.

       Ç bleibt draussen, aber nicht mehr wegen eines Defekts: In SEIDE war
       das Netz non-manifold, weil die Cedille der Italiana gegen das C
       laeuft; der neue Generator vereinigt sie, geslict bei 5, 10 und 15 cm
       ohne Warnung. Bei 20 cm passt es nicht aufs Bett. Ob Ç in den
       Zeichenvorrat kommt, ist eine offene Produktfrage — dann gehoerte es
       bei 20 cm in sperre20.

       Bewusst eine explizite Liste und KEINE Unicode-Range: Eine Range zoege
       Ç mit herein und dazu Dutzende Zeichen ohne Bauteil. Bei Erweiterung
       der Bibliothek hier nachziehen. */
    'éèêëáàâíìóòôúùûñåøç' +
    'ÉÈÊËÁÀÂÍÌÓÒÔÚÙÛÑÅØ' +
    "!&',-.?" +
    ' ';

  /* Buchstaben, die sich nur durch ein Akzentzeichen von einem erlaubten
     unterscheiden, bekommen eine eigene Rueckmeldung: Sie sind ein Wunsch,
     den wir noch nicht bedienen, kein Vertipper. Erkannt ueber die
     Unicode-Zerlegung (é = e + Akut), plus æ Æ œ Œ, die sich nicht zerlegen
     lassen. å Å ø Ø standen hier ebenfalls, sind aber seit der Bibliothek v3
     erlaubt (v4 ebenso) und werden hier nie mehr geprueft — die Liste sieht
     nur verworfene Zeichen. */
  var UNZERLEGBARE_AKZENTE = 'æÆœŒ';
  function istAkzentbuchstabe(ch) {
    if (UNZERLEGBARE_AKZENTE.indexOf(ch) > -1) return true;
    var blank = ch.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return blank !== ch && /^[A-Za-z]$/.test(blank);
  }

  /* Zerlegt in Codepoints, nicht in UTF-16-Einheiten: Ein Emoji ist ein
     Zeichen und wird als eines verworfen, nicht als zwei halbe. */
  function zeichenPruefen(text) {
    var sauber = '', verworfen = [];
    Array.from(String(text)).forEach(function (ch) {
      if (ERLAUBTE_ZEICHEN.indexOf(ch) > -1) sauber += ch;
      else verworfen.push(ch);
    });
    return { sauber: sauber, verworfen: verworfen };
  }

  /* Betragsformat, Bewegungs-Vorgabe und der Preis-Zaehler liegen seit
     dem 10. 8. in assets/lettra-zahlen.js — der Bubble-Konfigurator
     braucht dieselbe Logik. Die Datei wird per defer davor geladen
     (sections/lettra-configurator.liquid). */
  var Z = window.LettraZahlen;

  function charCount(t) {
    return t.replace(/\s/g, '').length;
  }

  function init(root) {
    if (root.dataset.init) return;
    root.dataset.init = 'true';

    var FONTS = window.LETTRA_FONTS || [];
    var els = {
      preview: root.querySelector('[data-cfg-preview]'),
      stagemeta: root.querySelector('[data-cfg-stagemeta]'),
      text: root.querySelector('[data-cfg-text]'),
      discountHint: root.querySelector('[data-cfg-discount-hint]'),
      fonts: root.querySelector('[data-cfg-fonts]'),
      sizes: root.querySelector('[data-cfg-sizes]'),
      sperre: root.querySelector('[data-cfg-sperre]'),
      sperreText: root.querySelector('[data-cfg-sperre-text]'),
      zeichen: root.querySelector('[data-cfg-zeichen]'),
      areas: root.querySelector('[data-cfg-areas]'),
      colors: root.querySelector('[data-cfg-colors]'),
      platz: root.querySelector('[data-cfg-platz]'),
      platzHint: root.querySelector('[data-cfg-platz-hint]'),
      sFont: root.querySelector('[data-cfg-s-font]'),
      sSize: root.querySelector('[data-cfg-s-size]'),
      sDim: root.querySelector('[data-cfg-s-dim]'),
      sArea: root.querySelector('[data-cfg-s-area]'),
      sColor: root.querySelector('[data-cfg-s-color]'),
      sChars: root.querySelector('[data-cfg-s-chars]'),
      discountRow: root.querySelector('[data-cfg-discount-row]'),
      sDiscount: root.querySelector('[data-cfg-s-discount]'),
      sTotal: root.querySelector('[data-cfg-s-total]'),
      cta: root.querySelector('[data-cfg-cta]'),
      ctaLabel: root.querySelector('[data-cfg-cta-label]'),
      ctaDots: root.querySelector('.lettra-btn__dots'),
      error: root.querySelector('[data-cfg-error]'),
    };

    var DISCOUNT_MIN = parseInt(root.dataset.discountMin, 10) || 10;
    var DISCOUNT_RATE = parseFloat(root.dataset.discountRate) || 0.1;

    /* ---------- Varianten ---------- */
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-lettra-variants]').textContent) || [];
    } catch (e) {
      variants = [];
    }
    function sizeFromOption(v) {
      var m = String(v).match(/\d+/);
      return m ? parseInt(m[0], 10) : null;
    }
    function areaFromOption(v) {
      return /au[sß]/i.test(String(v)) ? 'aussen' : 'innen';
    }
    var variantMap = {};
    variants.forEach(function (v) {
      var s1 = sizeFromOption(v.o1);
      var s2 = sizeFromOption(v.o2);
      var size, area;
      if (s1 !== null && SIZES.indexOf(s1) > -1) {
        size = s1;
        area = areaFromOption(v.o2);
      } else if (s2 !== null && SIZES.indexOf(s2) > -1) {
        size = s2;
        area = areaFromOption(v.o1);
      } else {
        return;
      }
      variantMap[area + ':' + size] = v;
    });
    var hasVariants = Object.keys(variantMap).length >= 2;

    function variantFor(area, size) {
      return variantMap[area + ':' + size] || null;
    }
    function unitPrice(area, size) {
      var v = variantFor(area, size);
      return v ? v.price : FALLBACK_PRICES[area][size];
    }
    /* Sichtbarer Fallback-Zustand (9. 8., docs/WERKZEUGFALLEN.md):
       Ein Fallback, der dieselben Werte liefert wie der echte Pfad,
       ist eine Tarnung — beim Bubble-Konfigurator zeigte die Seite
       fertige Preise aus der Prototyp-Liste, waehrend jede Bestellung
       am Kaufklick gescheitert waere. Fehlt die Variante zur gerade
       gewaehlten Kombination, macht render() den Zustand deshalb
       sichtbar statt still weiterzurechnen. Einmal je Seitenaufbau
       auch als Konsolen-Warnung mit dem, was ankam. Im Normalbetrieb
       tritt das nie ein. */
    var fallbackGemeldet = false;
    function fallbackMelden(area, size) {
      if (fallbackGemeldet) return;
      fallbackGemeldet = true;
      console.warn(
        '[lettra-configurator] Keine Variante für ' + area + ':' + size + ' cm — Fallback-Preise aktiv, Bestellung gesperrt.',
        variants.length
          ? variants.map(function (v) {
              var s1 = sizeFromOption(v.o1);
              var s2 = sizeFromOption(v.o2);
              var gelesen = null;
              if (s1 !== null && SIZES.indexOf(s1) > -1) gelesen = s1;
              else if (s2 !== null && SIZES.indexOf(s2) > -1) gelesen = s2;
              return { option1: v.o1, option2: v.o2, gelesen_groesse_cm: gelesen };
            })
          : 'keine Variantendaten (Produkt fehlt oder Template ohne Produkt)'
      );
    }

    /* ---------- State (Prefill via ?text=&font=) ---------- */
    var params = new URLSearchParams(window.location.search);
    /* Auch der vorbefuellte ?text=-Parameter laeuft durch den Filter: Sonst
       stuenden im Feld Zeichen, die sich nicht bestellen lassen. */
    var startText = zeichenPruefen((params.get('text') || DEFAULT_TEXT).slice(0, 40)).sauber;
    var startFont = 0;
    if (params.get('font')) {
      var fIdx = FONTS.findIndex(function (f) { return f.name === params.get('font').toUpperCase(); });
      if (fIdx > -1) startFont = fIdx;
    }
    var state = { text: startText, font: startFont, size: 15, area: 'innen', color: 'schwarz' };
    els.text.value = state.text;

    /* ---------- Breitenmessung (Canvas) ----------
       Die gewaehlte Groesse ist die VERSALHOEHE, nicht die em-Groesse. Frueher
       stand hier font-size = Zielhoehe; das ergab fuer "lettra." in NORD/10cm
       28 cm, real sind es 35,5 cm. Der Fehler ist der Faktor 1/capHeight —
       bei NORD rund 1,38.

       Gerechnet wird jetzt in zwei Schritten:
       1. capHeight aus der gemessenen Hoehe des "H" bei Referenzgroesse,
          daraus die Schriftgroesse, die die Zielhoehe wirklich trifft.
       2. Breite als Tintenausdehnung des Gesamttexts ueber
          actualBoundingBoxLeft + actualBoundingBoxRight. Die aeusseren
          Seitenraender sind darin nicht enthalten, die natuerlichen Abstaende
          zwischen den Buchstaben schon — genau so steht das Wort an der Wand.
          Reine Leerzeichen tragen dadurch nichts bei, was richtig ist: Sie
          werden nicht gedruckt.

       Faellt eine der beiden Messungen aus (alte Engine ohne
       actualBoundingBox*, Schrift noch nicht geladen), greift die alte
       Rechnung — lieber ein zu kleiner Wert als gar keiner. */
    var MESS_REF = 1000;

    /* ---------- calt und liga aus, auch beim Messen ----------
       Die STL-Bibliothek kennt nur die Grundglyphe je Zeichen. Mansalva
       (TINTA) und Caveat (CARA) tauschen ueber das OpenType-Feature calt je
       Wortposition Alternativformen ein, Libre Baskerville, Playfair,
       Montserrat und Baloo verschmelzen fi/fl/ff ueber liga — der Browser
       schaltet beides von sich aus ein, gedruckt wird es nie. Die Vorschau
       bekommt die Einstellung per CSS (.lettra-config__preview), der
       Mess-Canvas hier. Ein Canvas uebernimmt font-feature-settings NUR,
       wenn es im Dokument haengt — ein losgeloestes misst mit den
       Browser-Defaults (gemessen in Chrome 148, 1. 9. 2026: 948 gegen 986 px
       fuer "Laura Felix" in Mansalva bei 200 px). Deshalb wird es unsichtbar
       in die Section gehaengt. Mit calt und liga aus liefert measureText
       dieselben Werte wie HarfBuzz mit {kern} — auf 0,1 px nachgemessen. */
    var FEATURES_AUS = '"calt" 0, "liga" 0';
    function messCanvas(traeger) {
      var c = document.createElement('canvas');
      c.width = 1;
      c.height = 1;
      c.hidden = true;
      c.setAttribute('aria-hidden', 'true');
      c.style.fontFeatureSettings = FEATURES_AUS;
      traeger.appendChild(c);
      return c.getContext('2d');
    }
    var mctx = messCanvas(root);

    /* ---------- Versalhoehe: die eine Bezugsgroesse ----------
       Die verkaufte Groesse IST die Versalhoehe. Alles, was eine Schrift
       darstellt, regelt deshalb darauf und nicht auf die font-size: Die zehn
       Schriften bauen bei gleicher px-Zahl von 0,63 (BOLLA) bis 0,81 (CARA)
       hoch — bis zu 30 % Unterschied in dem, was der Kunde als
       Buchstabengroesse sieht. Festlegung in LETTRA_STATUS.md, Abschnitt 13.

       Gemessen, nicht tabelliert: Gesamthoehe des "H" (yMax − yMin) bei
       Referenzgroesse. Genau so skaliert der STL-Generator. */
    function versalFaktor(f) {
      mctx.font = f.w + ' ' + MESS_REF + 'px ' + f.css.replace(/'/g, '"');
      var h = mctx.measureText('H');
      if (typeof h.actualBoundingBoxAscent !== 'number') return 0;
      return (h.actualBoundingBoxAscent + h.actualBoundingBoxDescent) / MESS_REF;
    }

    /* Ankerpunkt fuer den Maszstab der Vorschau-Wand und der Schriftproben.
       0,706 ist der Median der zehn gemessenen Faktoren (7.8.2026):

         BOLLA 0,625 · ATRIO/GRAT/SEIDE 0,700 · TINTA 0,704 · VIENNE 0,708
         NORD 0,728 · NOA 0,764 · ELDA 0,770 · CARA 0,814

       Der Median haelt den typischen Fall dort, wo er vor der Umstellung war:
       Eine Schrift mit Faktor 0,706 bekommt exakt dieselbe Groesse wie mit der
       alten px-Rechnung, die uebrigen wandern um ihren Abstand zum Median.

       Bewusst eine Konstante und keine Live-Rechnung ueber alle zehn: Die
       Displayschriften laden erst bei Bedarf: Ein Median ueber teils noch
       nicht geladene Schriften waere der Median der Ersatzschrift und wuerde
       den Maszstab bei jedem Aufruf anders verschieben. Eine einzelne
       Konstante ist keine Faktorentabelle — die Faktoren selbst werden nach
       wie vor gemessen. Kommt eine elfte Schrift dazu, gehoert der Wert neu
       gebildet; die Zeile darueber sagt, aus welchen Zahlen. */
    var VERSAL_MEDIAN = 0.706;

    /* ---------- Zielhoehen der Vorschau-Wand ----------
       Vier fest hinterlegte Versalhoehen in px, auf jeder Bildschirmbreite
       dieselben. Keine Anteilsrechnung, kein Boden, keine zweite Formel.
       Die Schritte sind gleich gross (20px), die Stufen dadurch klar
       unterscheidbar. */
    var ZIEL_VERSAL = { 5: 50, 10: 70, 15: 90, 20: 110 };
    function zielVersal(cm) {
      if (ZIEL_VERSAL[cm]) return ZIEL_VERSAL[cm];
      /* Nur fuer eine kuenftige Stufe, die hier noch nicht steht: dieselbe
         Gerade weitergefuehrt (30 + cm × 4 trifft alle vier Werte oben). */
      return 30 + cm * 4;
    }
    var GROESSTE_STUFE = SIZES[SIZES.length - 1];

    function breiteCm(text, fontIdx, sizeCm) {
      if (!text) return 0;
      var f = FONTS[fontIdx];
      mctx.font = f.w + ' ' + MESS_REF + 'px ' + f.css.replace(/'/g, '"');

      var h = mctx.measureText('H');
      /* Bezugshoehe ist die GESAMTHOEHE des H (yMax − yMin), nicht nur yMax.
         Genau so skaliert der STL-Generator (versalhoehe in
         lettra_letter_generator_v2.py). Bei sechs Schriften steht das H auf
         der Grundlinie, dort ist beides gleich; bei CARA ragt es 91 von 1000
         Einheiten darunter, und die Breitenangabe war um 12,6 % zu gross —
         ein 20-cm-"Familie Gruber" wurde mit 138 statt 122 cm angekuendigt.
         actualBoundingBoxDescent traegt den Teil unter der Grundlinie und ist
         negativ, wenn die Glyphe ganz darueber liegt; die Summe stimmt in
         beiden Faellen. Gegengerechnet gegen masse.csv (4560 Zeilen; damals
         der Blender-Lauf, den seine eigene Ausgabe "V4.1" nannte — nicht zu
         verwechseln mit der Version von stl_bibliothek.py. Die Werte gelten
         in ~/lettra-stl-v4 unveraendert weiter): ATRIO, BOLLA, ELDA, GRAT
         und SEIDE treffen danach auf 0,005 mm. */
      var capHeight = (h.actualBoundingBoxAscent + h.actualBoundingBoxDescent) / MESS_REF;
      var m = mctx.measureText(text);
      var tinte = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;

      if (!(capHeight > 0) || !(tinte > 0)) {
        mctx.font = f.w + ' 100px ' + f.css.replace(/'/g, '"');
        return (mctx.measureText(text).width / 100) * sizeCm;
      }
      return (tinte / MESS_REF) * (sizeCm / capHeight);
    }
    function passendeGroesse(platzCm) {
      var best = null;
      SIZES.forEach(function (s) {
        if (breiteCm(state.text || 'Dein Text', state.font, s) <= platzCm) best = s;
      });
      return best;
    }

    /* ---------- Optionen bauen ---------- */
    function optButton(cls, html, onSelect) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.setAttribute('role', 'radio');
      b.innerHTML = html;
      b.addEventListener('click', onSelect);
      return b;
    }

    FONTS.forEach(function (f, i) {
      els.fonts.appendChild(
        optButton(
          'lettra-opt',
          '<span class="sample" data-versal="' + i + '" style="font-family:' + f.css + ';font-weight:' + f.w + '">Aa</span>' +
            '<span class="fname">' + f.name + '</span><small>' + f.desc + '</small>',
          function () { state.font = i; render({ swapPreview: true }); }
        )
      );
      if (f.divider) {
        var d = document.createElement('div');
        d.className = 'lettra-font-divider';
        d.setAttribute('aria-hidden', 'true');
        els.fonts.appendChild(d);
      }
    });

    /* Die zehn "Aa"-Proben stehen untereinander und sollen gleich gross
       aussehen — also gleiche Versalhoehe, nicht gleiche font-size. Auf den
       21 px aus dem CSS lagen zwischen BOLLA (13,1 px Versalhoehe) und CARA
       (17,1 px) 30 % Unterschied, direkt nebeneinander sichtbar.
       Zielhoehe sind dieselben 21 px am Median, damit sich der Eindruck der
       Liste insgesamt nicht verschiebt. Das CSS behaelt seine 21 px als
       Rueckfall, wenn hier nichts gesetzt wird. */
    var PROBE_VERSAL = 21 * VERSAL_MEDIAN;
    function probenAufVersalhoehe() {
      Array.prototype.slice.call(els.fonts.querySelectorAll('.sample[data-versal]')).forEach(function (s) {
        var cap = versalFaktor(FONTS[+s.dataset.versal]);
        if (cap > 0) s.style.fontSize = (PROBE_VERSAL / cap).toFixed(2) + 'px';
      });
    }
    probenAufVersalhoehe();
    /* Beim ersten Durchlauf misst der Canvas womoeglich noch die
       Ersatzschrift — dieselbe Falle wie bei der Vorschau. Nach dem Laden
       genau einmal nachziehen. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(probenAufVersalhoehe, function () {});
    }

    SIZES.forEach(function (s) {
      els.sizes.appendChild(
        optButton(
          'lettra-opt',
          /* Die Passt-/Passt-nicht-Auskunft steckt zusätzlich als unsichtbarer
             Text in der Karte — sonst bekämen Screenreader nur den Haken,
             der rein dekorativ ist. */
          '<strong>' + s + '</strong><small>cm</small>' +
            '<span class="visually-hidden" data-fit-note></span>',
          function () {
            /* Gesperrte Groesse ignoriert den Klick. disabled allein genuegt
               nicht: Der Zustand kann sich durch Text- oder Schriftwechsel
               aendern, waehrend der Zeiger schon auf der Karte steht. */
            if (s === SPERR_GROESSE && zwanzigGesperrt()) return;
            state.size = s;
            render();
          }
        )
      );
    });

    AREAS.forEach(function (a) {
      els.areas.appendChild(
        optButton('lettra-opt lettra-opt--left', '<b>' + a.label + '</b><small>' + a.sub + '</small>', function () {
          state.area = a.id;
          render();
        })
      );
    });

    COLORS.forEach(function (c) {
      els.colors.appendChild(
        optButton(
          'lettra-opt lettra-opt--left',
          '<b><span class="swatch" style="background:' + c.chip + '"></span>' + c.label + '</b><small>gleicher Preis</small>',
          function () { state.color = c.id; render({ swapPreview: true }); }
        )
      );
    });

    /* ---------- Preis-Zähler (300ms Ziffern-Interpolation) ----------
       Die Mechanik steht in assets/lettra-zahlen.js; hier bleiben nur die
       Zustandsspeicher. Zwei davon: Summe und CTA-Betrag zeigen dieselbe
       Zahl, sind aber zwei Knoten mit zwei Animationen. */
    var totalAnim = Z.neuerZaehler();
    var ctaAnim = Z.neuerZaehler();
    function ctaBetrag(cents) {
      return 'In den Warenkorb · ' + Z.euro(cents);
    }

    /* ---------- Zeichensperre bei 20 cm ----------
       Anders als die Signale des Breiten-Planers ist das keine Einschaetzung,
       sondern eine physische Grenze: Das Zeichen passt bei 20 cm nicht mehr
       aufs Druckbett. Deshalb wird die Karte hart gesperrt und nicht nur
       optisch zurueckgenommen.
       Gross-/kleinschreibungssensitiv — kein toUpperCase(). */
    var SPERR_GROESSE = 20;
    var RUECKFALL_GROESSE = 15;

    function gesperrteZeichen(fontIdx, text) {
      var f = FONTS[fontIdx];
      if (!f || !f.sperre20 || !f.sperre20.length || !text) return [];
      return f.sperre20.filter(function (z) { return text.indexOf(z) !== -1; });
    }
    function zwanzigGesperrt() {
      return gesperrteZeichen(state.font, state.text).length > 0;
    }

    /* ---------- Zeichensperre in jeder Groesse ----------
       Zeichen, fuer die es in der gewaehlten Schrift kein brauchbares Bauteil
       gibt — Liste und Begruendung je Schrift in lettra-fonts.js (sperre).
       Dieselbe Mechanik wie sperre20, nur ohne Rueckfallgroesse: Es gibt
       keine Groesse, in der das Bauteil existiert. Deshalb bleibt der
       Warenkorb zu, solange das Zeichen im Text steht, und der Hinweis nennt
       Zeichen, Schrift und Ausweg. Gross-/kleinschreibungssensitiv.
       Wird vor der Preisrechnung bestimmt, damit nie ein Preis fuer ein
       nicht herstellbares Bauteil dasteht. */
    function hartGesperrteZeichen(fontIdx, text) {
      var f = FONTS[fontIdx];
      if (!f || !f.sperre || !f.sperre.length || !text) return [];
      return f.sperre.filter(function (z) { return text.indexOf(z) !== -1; });
    }
    /* Hinweistext: ç ist in keiner Schrift fertigbar, dafuer gibt es einen
       Ersatz im Text (c). Alle anderen gesperrten Zeichen sind nur in dieser
       Schrift betroffen — dort ist der Ausweg eine andere Schrift. */
    function hartGesperrtSaetze(f, zeichen) {
      var saetze = [];
      var nurHier = zeichen.filter(function (z) { return z !== 'ç'; });
      if (zeichen.indexOf('ç') !== -1) {
        saetze.push('Das ç können wir zurzeit in keiner Schrift fertigen — schreibe stattdessen c.');
      }
      if (nurHier.length) {
        saetze.push('In ' + f.name + ' lässt sich das ' + zeichenListe(nurHier) +
          ' nicht sauber fertigen. Wähle eine andere Schrift oder ändere den Text.');
      }
      return saetze;
    }
    function hartGesperrtText(f, zeichen) {
      return hartGesperrtSaetze(f, zeichen).join(' ');
    }
    /* „M und W" statt „M, W" — bei mehr als zwei Zeichen wird das letzte mit
       „und" angehaengt: „M, Q und W". */
    function zeichenListe(zeichen) {
      if (zeichen.length < 2) return zeichen.join('');
      return zeichen.slice(0, -1).join(', ') + ' und ' + zeichen[zeichen.length - 1];
    }

    /* ---------- Vorschau ----------
       Optische Mitte statt Box-Mitte: align-items: center zentriert die
       Zeilenbox. Deren Leerraum verteilt sich nach den Schriftmetriken, nicht
       nach dem tatsächlich gesetzten Wort — bei "FAMILIE GRUBER" in GRAT
       (nur Versalien) bleibt die ganze Unterlängen-Reserve unten leer, der
       Schriftzug sitzt entsprechend zu hoch. Gemessen wurden 38px Luft oben
       gegen 46px unten (GRAT) und 47 gegen 52 (ELDA).
       canvas measureText liefert mit actualBoundingBox* die echten
       Tintengrenzen des konkreten Wortes; daraus die Korrektur. Verschoben
       wird über top (position: relative), nicht über transform — dort liegt
       die Stauchung der Einpass-Logik. */
    var messCtx = null;
    try {
      /* Gleiche Einstellung wie beim Breiten-Canvas: calt und liga aus,
         im Dokument eingehaengt (Begruendung bei messCanvas). */
      messCtx = messCanvas(root);
    } catch (e) {
      messCtx = null;
    }
    function zentriereOptisch() {
      if (!messCtx || !els.preview.textContent) return;
      var cs = window.getComputedStyle(els.preview);
      messCtx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      var m;
      try {
        m = messCtx.measureText(els.preview.textContent);
      } catch (e) {
        return;
      }
      /* actualBoundingBox* fehlt in älteren Browsern — dann bleibt es bei der
         Box-Mitte, das ist der Zustand von vorher. */
      if (!m || typeof m.actualBoundingBoxAscent !== 'number' || typeof m.fontBoundingBoxAscent !== 'number') return;
      var boxH = els.preview.getBoundingClientRect().height;
      if (!(boxH > 0)) return;
      var baseline = (boxH - (m.fontBoundingBoxAscent + m.fontBoundingBoxDescent)) / 2 + m.fontBoundingBoxAscent;
      var tinteMitte = baseline - (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2;
      els.preview.style.top = Math.round(boxH / 2 - tinteMitte) + 'px';
    }

    function paintPreview() {
      var f = FONTS[state.font];
      var text = state.text || 'Dein Text';
      els.preview.textContent = text;
      els.preview.style.fontFamily = f.css;
      els.preview.style.fontWeight = f.w;
      els.preview.classList.toggle('ink', state.color === 'schwarz');
      els.preview.classList.toggle('snow', state.color !== 'schwarz');
      var wall = els.preview.parentElement;

      /* base ist die maßstabsgetreue Größe: Sie wächst mit der gewählten
         Buchstabenhöhe und ist die Obergrenze. Passt sie nicht in die Wand,
         verkleinert die gemeinsame Einpass-Logik so weit, dass Breite UND
         Höhe hineingehen — gemessen, nicht aus der Zeichenzahl geschätzt.
         Die alte Schätzung brach bei „Das fasching" in ATRIO/25 cm auf 375px
         in zwei Zeilen um und machte die Maßangabe daneben unwahr.

         Die Wand zeigt eine VERSALHÖHE, keine font-size. Vorher stand hier
         `26 + size * 3.4` als Schriftgröße — dieselbe Zahl für alle zehn
         Schriften, und damit zeigte dieselbe gewählte Größe in BOLLA 48 px
         Buchstabenhöhe und in CARA 63 px. Die Maßangabe daneben rechnete
         schon immer über die Versalhöhe; Wand und Zahl widersprachen sich
         also um bis zu 30 %. Die Zielhöhe steht jetzt als feste
         Versalhöhe in ZIEL_VERSAL, die Schriftgröße folgt der jeweiligen
         Schrift. */
      /* DER MASSSTAB DER WAND IST BEWUSST GESTAUCHT und NICHT proportional
         zur echten Groesse. Die Wand ZEIGT den Groessenunterschied zwischen
         den vier Stufen, sie MISST ihn nicht.

         Fuehrend bleibt die Massangabe daneben: "Maße ca." rechnet
         unveraendert ueber breiteCm() und wandert ueber
         properties[Maße ca.] in Bestellung, Bestaetigungsmail und
         Produktionsschein. Wer Zentimeter braucht, liest die Zahl.

         Die Zielhoehe haengt an der WANDHOEHE, nicht an festen px: Auf 1440
         ist die Wand 664px hoch innen, eine feste Leiter liess den
         Schriftzug dort auf 10 % der Hoehe verhungern. Als Anteil waechst er
         mit dem Schirm mit. Die vier Stufen in gleich grossen Schritten von
         2,5 Prozentpunkten:

           5 cm 12,5 %   10 cm 15 %   15 cm 17,5 %   20 cm 20 %

         DER BODEN ist kein Detail, sondern der Grund, warum hier ein max()
         steht: Mobil ist die Wand nur 126px hoch innen (Stage 24vh, minus
         Meta-Zeile und Polsterung), und beim Tippen schrumpft sie weiter auf
         "kompakt". Der Anteil allein ergaebe dort 15 bis 25px — die Regel,
         die Desktop rettet, wuerde das Telefon ruinieren. Der Boden ist die
         fruehere px-Leiter (48 + cm × 2,3) × Median; mobil gewinnt er,
         ab Desktop der Anteil.

         Der Umschlag liegt bei allen vier Stufen zwischen 332 und 336px
         Wandhoehe, also praktisch bei einer einzigen Schwelle — kein
         Flickenteppich aus vier Sonderfaellen, sondern eine Kante. Das ist
         Absicht: Die Anteile sind so gewaehlt, dass sie mit der alten Leiter
         an derselben Stelle zusammentreffen.

         Was hier NICHT angeruehrt ist: wie die Zielhoehe auf die Schriften
         verteilt wird. Jede der zehn erreicht bei derselben cm-Stufe
         weiterhin exakt dieselbe sichtbare Buchstabenhoehe (Abschnitt 13 der
         Statusdatei). Geaendert hat sich nur, WELCHE Hoehe eine Stufe
         bekommt. */
      /* DIE DECKELUNG WIRD EINMAL AUS DER GROESSTEN STUFE GERECHNET und dann
         auf alle vier angewandt. Vorher deckelte die Einpass-Logik jede Stufe
         fuer sich — und weil ein langer Text bei 15 UND bei 20 cm an denselben
         Rand stiess, zeigten beide dieselbe Groesse. Die Leiter verschwand
         genau dort, wo der Kunde sie zum Vergleichen braucht.

         Jetzt wird gefragt: Wie weit passt die GROESSTE Stufe? Ergibt das
         80 %, zeigen alle vier 80 % ihres Zielwerts — 88 / 72 / 56 / 40 px.
         Die Abstaende bleiben dadurch immer erhalten, egal wie lang der Text
         ist. Und weil jede kleinere Stufe strikt kleiner ist als die
         geprueft passende groesste, passt sie zwangslaeufig auch: eine
         zweite Deckelung kann es gar nicht mehr geben.

         Die Probe laeuft ueber lettraFit mit min: 1 — die Untergrenze wuerde
         den Messwert verfaelschen, und sie wird hier nicht gebraucht: Was
         passt, entscheidet die groesste Stufe, nicht ein Mindestwert.

         Fuehrend bleibt die Massangabe daneben. Die Wand ZEIGT den
         Groessenunterschied, sie MISST ihn nicht. */
      var cap = versalFaktor(f);

      function groesseSetzen(capWert) {
        if (!(capWert > 0) || !window.lettraFit || !wall) {
          /* Rueckfall ohne Messung: dieselben vier Werte, nur als font-size
             statt als Versalhoehe — ohne cap laesst sich nicht umrechnen. */
          els.preview.style.fontSize = zielVersal(state.size) + 'px';
          els.preview.style.transform = '';
          return;
        }
        var probeMax = zielVersal(GROESSTE_STUFE) / capWert;
        window.lettraFit(els.preview, wall, { min: 1, max: probeMax });
        var passt = parseFloat(els.preview.style.fontSize) || probeMax;
        /* Die Probe darf keine Stauchung hinterlassen: Sie gehoert zur
           Messung, nicht zur Anzeige. */
        els.preview.style.transform = '';
        var faktor = probeMax > 0 ? Math.min(1, passt / probeMax) : 1;
        els.preview.style.fontSize = ((zielVersal(state.size) / capWert) * faktor).toFixed(2) + 'px';
      }

      groesseSetzen(cap);
      zentriereOptisch();

      /* Die Displayschriften werden erst geladen, wenn sie zum ersten Mal
         gebraucht werden. Beim Wechsel auf eine noch ungeladene Schrift misst
         der Fit oben also die Ersatzschrift — danach gezielt nachladen und
         genau einmal nachjustieren. */
      if (document.fonts && document.fonts.load) {
        var probe = f.w + ' ' + window.lettraFitMeasurePx + 'px ' + f.css;
        if (!document.fonts.check(probe, text)) {
          document.fonts.load(probe, text).then(function () {
            /* Neu messen, nicht den alten Wert wiederverwenden: cap stammt
               aus versalFaktor(), und das mass eben noch die Ersatzschrift. */
            groesseSetzen(versalFaktor(f));
            zentriereOptisch();
          }, function () {});
        }
      }
    }
    function updatePreview(swap) {
      if (swap && !Z.reducedMotion()) {
        /* 180ms Cross-Fade: 90ms raus, Inhalt tauschen, 90ms rein */
        els.preview.classList.add('is-swapping');
        setTimeout(function () {
          paintPreview();
          els.preview.classList.remove('is-swapping');
        }, 90);
      } else {
        paintPreview();
      }
    }

    /* ---------- Render ---------- */
    function markSelected(container, index) {
      Array.prototype.slice.call(container.querySelectorAll('.lettra-opt')).forEach(function (el, i) {
        el.classList.toggle('is-selected', i === index);
        el.setAttribute('aria-checked', i === index ? 'true' : 'false');
      });
    }

    function render(opts) {
      opts = opts || {};

      /* Reihenfolge: Text und Schrift bestimmen die Sperre, die Sperre
         bestimmt die Groesse. Steht 20 cm noch gewaehlt, obwohl der neue Text
         oder die neue Schrift sie sperrt, faellt die Auswahl auf 15 cm
         zurueck — vor jeder Preisrechnung, sonst stuende kurz ein Preis fuer
         eine nicht herstellbare Groesse da. */
      var gesperrt = gesperrteZeichen(state.font, state.text);
      if (gesperrt.length > 0 && state.size === SPERR_GROESSE) {
        state.size = RUECKFALL_GROESSE;
      }
      var hart = hartGesperrteZeichen(state.font, state.text);

      var f = FONTS[state.font];
      var n = charCount(state.text);
      var pEach = unitPrice(state.area, state.size);
      var brutto = n * pEach;
      var hatRabatt = n >= DISCOUNT_MIN;
      var total = hatRabatt ? Math.round(brutto * (1 - DISCOUNT_RATE)) : brutto;

      updatePreview(opts.swapPreview);

      var bCm = breiteCm(state.text, state.font, state.size);
      els.stagemeta.textContent = bCm
        ? '≈ ' + Math.round(bCm) + ' cm breit · ' + state.size + ' cm hoch'
        : state.size + ' cm Buchstabenhöhe';
      els.sDim.textContent = bCm ? Math.round(bCm) + ' × ' + state.size + ' cm' : '–';

      /* ---------- Zeichensperre: Karte und Hinweis ---------- */
      Array.prototype.slice.call(els.sizes.querySelectorAll('.lettra-opt')).forEach(function (el, i) {
        var sperrt = SIZES[i] === SPERR_GROESSE && gesperrt.length > 0;
        el.classList.toggle('lettra-opt--gesperrt', sperrt);
        el.disabled = sperrt;
        el.setAttribute('aria-disabled', sperrt ? 'true' : 'false');
      });
      /* Zwei Meldungen, zwei Orte, zwei Elemente: Die schriftbezogene
         Sperre steht unter dem Textfeld (sie kommt vom Text), die 20-cm-
         Sperre unter den Groessen (sie kommt von der Groesse). Greifen
         beide, stehen beide — keine teilt sich ein Element mit der anderen,
         also ueberschreibt keine die andere. */
      if (els.sperreText) {
        els.sperreText.hidden = hart.length === 0;
        /* Ein Satz je Zeile: greifen mehrere Sperren, stehen sie
           untereinander (white-space: pre-line im CSS), nicht als ein
           langer Absatz. */
        els.sperreText.textContent = hart.length > 0 ? hartGesperrtSaetze(f, hart).join('\n') : '';
      }
      if (els.sperre) {
        els.sperre.hidden = gesperrt.length === 0;
        els.sperre.textContent = gesperrt.length > 0
          ? 'In ' + f.name + ' passt das ' + zeichenListe(gesperrt) + ' bei ' +
            SPERR_GROESSE + ' cm nicht auf unser Druckbett. Wähle 15 cm oder eine andere Schrift.'
          : '';
      }

      /* ---------- Platz-Planer ----------
         Zwei Rückmeldungen: Signale an den einzelnen Größenkarten und eine
         Zeile darunter. Ohne eingegebene Breite (oder ohne Text) bleibt beides
         aus — die Karten sehen dann aus wie zuvor. */
      var platz = parseFloat(els.platz.value);
      var planerAktiv = platz > 0 && n > 0;

      Array.prototype.slice.call(els.sizes.querySelectorAll('.lettra-opt')).forEach(function (el, i) {
        var passt = planerAktiv && breiteCm(state.text, state.font, SIZES[i]) <= platz;
        el.classList.toggle('lettra-opt--fits', passt);
        el.classList.toggle('lettra-opt--wide', planerAktiv && !passt);
        var note = el.querySelector('[data-fit-note]');
        if (note) {
          note.textContent = planerAktiv
            ? passt
              ? ' — passt in ' + platz + ' cm'
              : ' — breiter als ' + platz + ' cm'
            : '';
        }
      });

      if (planerAktiv) {
        var empf = passendeGroesse(platz);
        var passtGewaehlte = bCm > 0 && bCm <= platz;
        if (empf === null) {
          els.platzHint.textContent = 'Dein Text ist selbst in 5 cm zu breit — kürze ihn oder plane mehr Platz ein.';
          els.platzHint.className = 'lettra-hint';
        } else if (passtGewaehlte) {
          els.platzHint.textContent = '✓ Passt: ' + Math.round(bCm) + ' cm von ' + platz + ' cm genutzt.';
          els.platzHint.className = 'lettra-hint lettra-hint--ok';
        } else {
          /* Sachlich, ohne Warnfarbe: erst die beiden Zahlen, dann der
             klickbare Vorschlag. Die Größe bleibt trotzdem wählbar. */
          els.platzHint.className = 'lettra-hint';
          els.platzHint.innerHTML =
            state.size + ' cm ergibt ' + Math.round(bCm) + ' cm Breite — zu viel für ' + platz +
            ' cm. <button type="button" class="lettra-planner__apply" data-apply-size="' + empf + '">' +
            empf + ' cm</button> passt (≈ ' + Math.round(breiteCm(state.text, state.font, empf)) + ' cm).';
          els.platzHint.querySelector('[data-apply-size]').addEventListener('click', function () {
            state.size = empf;
            render();
          });
        }
      } else {
        els.platzHint.textContent = '';
        els.platzHint.className = 'lettra-hint';
      }

      /* Auswahl-Markierungen */
      markSelected(els.fonts, state.font);
      markSelected(els.sizes, SIZES.indexOf(state.size));
      markSelected(els.areas, state.area === 'innen' ? 0 : 1);
      markSelected(els.colors, state.color === 'schwarz' ? 0 : 1);

      /* Zusammenfassung */
      els.sFont.textContent = f.name;
      els.sSize.textContent = state.size + ' cm';
      els.sArea.textContent = state.area === 'innen' ? 'Innenbereich' : 'Außenbereich';
      els.sColor.textContent = state.color === 'schwarz' ? 'Schwarz matt' : 'Weiß';
      els.sChars.textContent = n + ' × ' + Z.euro(pEach);

      /* Rabatt-Hinweis (Countdown ohne Animation) */
      if (hatRabatt) {
        els.discountHint.textContent = '✓ Mengenrabatt aktiv: −10 % auf diesen Schriftzug';
        els.discountHint.className = 'lettra-hint lettra-hint--ok';
      } else if (n > 0) {
        els.discountHint.textContent = 'Noch ' + (DISCOUNT_MIN - n) + ' Zeichen, dann bekommst du −10 % auf diesen Schriftzug';
        els.discountHint.className = 'lettra-hint';
      } else {
        els.discountHint.textContent = '';
      }

      /* Rabattzeile: 250ms height + opacity */
      var wrap = els.discountRow;
      if (hatRabatt) {
        els.sDiscount.textContent = '−' + Z.euro(Math.round(brutto * DISCOUNT_RATE));
        if (!wrap.classList.contains('is-open')) {
          wrap.classList.add('is-open');
          wrap.style.height = wrap.scrollHeight + 'px';
        }
      } else if (wrap.classList.contains('is-open')) {
        wrap.classList.remove('is-open');
        wrap.style.height = '0px';
        /* Betrag mitraeumen: Sonst steht der Wert des Vorzustands weiter im
           DOM — unsichtbar, solange die Zeile zu ist, aber sichtbar in dem
           Moment, in dem sie wieder aufklappt, bevor render() ihn neu setzt. */
        els.sDiscount.textContent = '';
      }

      /* Fallback sichtbar machen statt fertig aussehen zu lassen —
         Begruendung bei fallbackMelden(). */
      if (!variantFor(state.area, state.size)) {
        fallbackMelden(state.area, state.size);
        /* festerText bricht eine laufende Animation ab, bevor es den
           Ersatztext setzt — sonst schriebe der naechste Frame noch einmal
           einen Preis in das Element, das gerade "wird geprüft" sagt.
           Ohne Wertangabe: Die gemerkte Zahl bleibt stehen, damit der
           Zaehler bei einer wieder gueltigen Kombination dort ansetzt, wo
           die Anzeige zuletzt stand. */
        Z.festerText(els.sTotal, totalAnim, 'Preis wird geprüft');
        Z.festerText(els.ctaLabel, ctaAnim, 'Gerade nicht bestellbar');
        els.cta.toggleAttribute('disabled', true);
        hideError();
        return;
      }

      Z.zaehleAuf(els.sTotal, totalAnim, total);

      /* CTA */
      var disabled = n === 0 || hart.length > 0;
      els.cta.toggleAttribute('disabled', disabled);
      if (hart.length > 0) {
        /* Nicht herstellbares Zeichen im Text: kein Betrag auf dem Button,
           der Hinweis unter den Groessen sagt, was zu tun ist. */
        Z.festerText(els.ctaLabel, ctaAnim, 'Text anpassen');
      } else if (n) {
        Z.zaehleAuf(els.ctaLabel, ctaAnim, total, ctaBetrag);
      } else {
        /* Leerer Text zeigt keinen Betrag — der gemerkte Wert wird
           trotzdem auf 0 nachgezogen. Sonst liefe der Button beim
           naechsten Zeichen von der alten Summe los, waehrend die
           Zusammenfassung daneben bei 0 startet. */
        Z.festerText(els.ctaLabel, ctaAnim, 'In den Warenkorb', 0);
      }
      hideError();
    }

    /* ---------- Fehler ---------- */
    function showError(msg) {
      els.error.textContent = msg;
      els.error.classList.add('is-visible');
    }
    function hideError() {
      els.error.classList.remove('is-visible');
    }

    /* ---------- Warenkorb ---------- */
    function setLoading(on) {
      els.cta.classList.toggle('lettra-btn--loading', on);
      els.ctaDots.hidden = !on;
      els.cta.toggleAttribute('aria-disabled', on);
    }

    function addToCart() {
      var n = charCount(state.text);
      if (!n) {
        showError('Gib zuerst deinen Text ein.');
        els.text.focus();
        return;
      }
      /* Zweite Absicherung: Der Filter im Feld faengt Tippen und Einfuegen ab,
         diese Pruefung faengt alles andere — vorbefuellter ?text=-Parameter,
         Autofill, manipuliertes DOM. Nichts Unerlaubtes geht in den Warenkorb. */
      var zPruef = zeichenPruefen(state.text);
      if (zPruef.verworfen.length) {
        zeichenHinweis(zPruef.verworfen);
        showError('Im Text stehen Zeichen, die wir nicht drucken können.');
        els.text.focus();
        return;
      }
      /* Schriftbezogene Sperre (lettra-fonts.js, sperre): render() haelt den
         Button zu, diese Pruefung faengt den Rest — Klick per Tastatur auf
         ein manipuliertes DOM, Aufruf von aussen. */
      var hartGesperrt = hartGesperrteZeichen(state.font, state.text);
      if (hartGesperrt.length) {
        showError(hartGesperrtText(FONTS[state.font], hartGesperrt));
        els.text.focus();
        return;
      }
      var variant = variantFor(state.area, state.size);
      if (!variant) {
        showError('Diese Kombination ist gerade nicht bestellbar. Bitte melde dich kurz bei uns.');
        return;
      }
      if (!variant.available) {
        showError('Diese Kombination ist gerade nicht verfügbar.');
        return;
      }

      var f = FONTS[state.font];
      var bCm = Math.round(breiteCm(state.text, state.font, state.size));
      setLoading(true);
      hideError();

      var formData = new FormData();
      formData.append('id', variant.id);
      formData.append('quantity', n);
      /* Reihenfolge = Anzeigereihenfolge im Warenkorb. Der Text steht zuerst,
         weil er das Einzige ist, was der Kunde auf Tippfehler pruefen muss.
         Groesse und Bereich sind Varianten, keine Properties — sie rendert
         Shopify in einer eigenen Schleife vor den Properties und laesst sich
         von hier aus nicht dazwischenschieben. */
      formData.append('properties[Text]', state.text);
      formData.append('properties[Schriftart]', f.name + ' — ' + f.desc);
      formData.append('properties[Maße ca.]', bCm + ' × ' + state.size + ' cm');
      formData.append('properties[Farbe]', state.color === 'schwarz' ? 'Schwarz matt' : 'Weiß');

      var cart = document.querySelector('cart-drawer');
      if (cart && cart.getSectionsToRender) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (s) { return s.id; })
        );
        formData.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData,
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          setLoading(false);
          if (data.status) {
            showError(data.description || data.message || 'Das hat leider nicht geklappt. Versuch es bitte noch einmal.');
            return;
          }
          if (cart && cart.renderContents) {
            cart.renderContents(data);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          setLoading(false);
          showError('Keine Verbindung. Prüfe deine Internetverbindung und versuch es noch einmal.');
        });
    }

    /* ---------- Events ---------- */
    /* Rueckmeldung zum Zeichenvorrat. Auszeichnung und Verhalten wie beim
       20-cm-Hinweis: dieselbe .lettra-hint, hidden solange nichts anliegt,
       aria-live fuer Screenreader. Sie steht unter dem Textfeld und nicht
       unter den Groessen, weil dort verworfen wird. */
    function zeichenHinweis(verworfen) {
      if (!els.zeichen) return;
      if (!verworfen.length) {
        els.zeichen.hidden = true;
        els.zeichen.innerHTML = '';
        return;
      }
      var akzente = verworfen.some(istAkzentbuchstabe);
      var anderes = verworfen.some(function (ch) { return !istAkzentbuchstabe(ch); });
      var teile = [];
      if (akzente) {
        /* Nicht mehr "Buchstaben mit Akzent": Die meisten sind erlaubt und
           stehen so auch in der Hilfezeile darueber. Uebrig bleiben Ç und
           seltenere wie ï ã õ ý æ œ — die Meldung spricht deshalb von
           diesem Buchstaben, nicht von einer ganzen Klasse. */
        teile.push(
          'Diesen Buchstaben können wir noch nicht drucken. ' +
          '<a href="/pages/kontakt">Schreib uns kurz</a>, wenn du ihn brauchst.'
        );
      }
      if (anderes) teile.push('Dieses Zeichen können wir nicht drucken.');
      els.zeichen.innerHTML = teile.join(' ');
      els.zeichen.hidden = false;
    }

    /* Unerlaubte Zeichen erscheinen gar nicht erst im Feld, beim Tippen wie
       beim Einfuegen. Die Cursorposition wird aus dem gefilterten Praefix
       neu berechnet — sonst springt er beim Korrigieren mitten im Wort ans
       Ende. Gerechnet wird in UTF-16-Einheiten, weil selectionStart das auch
       tut: Ein verworfenes Emoji verschiebt um zwei, nicht um eins. */
    els.text.addEventListener('input', function (e) {
      var feld = e.target;
      var roh = feld.value;
      var pruef = zeichenPruefen(roh);
      if (pruef.verworfen.length) {
        var pos = feld.selectionStart;
        var neuePos = zeichenPruefen(roh.slice(0, pos)).sauber.length;
        feld.value = pruef.sauber;
        try { feld.setSelectionRange(neuePos, neuePos); } catch (err) {}
      }
      zeichenHinweis(pruef.verworfen);
      state.text = feld.value;
      render();
    });
    els.platz.addEventListener('input', function () { render(); });
    els.cta.addEventListener('click', addToCart);

    /* Die Wand ändert ihre Größe auch ohne resize-Event — etwa wenn die
       Stage-Höhe unten neu gesetzt wird. Dann muss neu eingepasst werden,
       sonst steht die Vorschau zu groß in einer geschrumpften Wand. */
    var wall = els.preview ? els.preview.parentElement : null;
    if (wall && window.lettraFitObserve) {
      window.lettraFitObserve(wall, function () { paintPreview(); });
    }

    /* Header-Höhe für sticky Vorschau */
    function setHeaderHeight() {
      var header = document.querySelector('.section-header');
      if (header) {
        document.documentElement.style.setProperty('--lettra-header-h', header.offsetHeight + 'px');
      }
    }

    /* Sichtbare Höhe der Vorschau-Stage auf Desktop.
       100vh minus Header reicht nicht: Darüber liegt noch die
       Ankündigungsleiste, sodass die Meta-Zeile am Fuß der Stage genau um
       deren Höhe unter den Fold rutschte — und gerade diese Zeile
       („maßstabsgetreu simuliert", Maßangabe) verkauft die Vorschau.
       Deshalb ab dem tatsächlichen Abstand zum Seitenanfang rechnen.
       offsetTop bleibt bei position: sticky die statische Position, taugt
       also auch dann, wenn die Stage gerade klebt. */
    function setStageHeight() {
      var stage = root.querySelector('.lettra-config__stage');
      if (!stage) return;
      /* Dokumentposition über das Rechteck des Abschnitts, nicht über eine
         offsetTop-Kette. Die Kette hängt daran, welche Vorfahren positioniert
         sind: Nach dem Einzug der Wand-Spalte lieferte sie 377 statt 109, die
         Stage wurde 523px statt 791px hoch und die Wand endete mitten im
         Bild. Genau dieses Verhalten ist auch am Gerät aufgefallen.
         Der Abschnitt selbst klebt nicht und liegt bündig an der Oberkante
         der Stage — sein Rechteck plus scrollY ist die Dokumentposition,
         unabhängig von Scrollstand und Positionierung der Vorfahren. */
      var top = Math.round(root.getBoundingClientRect().top + window.scrollY);
      /* Die Stage endet exakt an der Fold-Kante. Vorher lagen hier 16px
         Reserve — die waren als Luft für die Meta-Zeile gedacht, wurden aber
         zu einem weißen Streifen unter der Wand: Die Wandfarbe sitzt auf der
         Stage, also endet sie mit ihr, und die klebende Stage schiebt den Rest
         der Spalte nie ins Bild. Die Luft steckt jetzt als zusätzliche
         Polsterung in der Meta-Zeile (siehe .lettra-config__stagemeta ab
         920px) — dort erfüllt sie denselben Zweck ohne Spalt. */
      var visible = Math.max(240, window.innerHeight - top);
      /* Nur schreiben, wenn sich der Wert wirklich ändert. Ein Schreibzugriff
         ändert die Stage-Höhe, das ändert die Größe der Wandfläche, das weckt
         den ResizeObserver — ohne diese Sperre wäre eine Schleife möglich, in
         der sich die Höhe „nach einer Weile einrenkt". */
      if (stage.style.getPropertyValue('--lettra-stage-h') === visible + 'px') return;
      stage.style.setProperty('--lettra-stage-h', visible + 'px');
    }

    /* ---------- Neuberechnung: nur bei echten Layout-Änderungen ----------
       Bezugsgröße ist der Layout-Viewport (window.innerWidth/Height), nicht
       der visuelle. Auf iOS schrumpft beim Öffnen der Tastatur ausschließlich
       der visuelle Viewport — eine Neuberechnung darauf hin würde die
       Vorschau umbauen, genau während der Kunde tippt und sie am meisten
       braucht. Deshalb zwei Sperren: Es wird nur gerechnet, wenn sich der
       Layout-Viewport tatsächlich geändert hat (Rotation, Fensterbreite), und
       nie, solange ein Eingabefeld im Konfigurator den Fokus hat. */
    var letzteGroesse = { w: window.innerWidth, h: window.innerHeight };
    function tippt() {
      var a = document.activeElement;
      if (!a || !root.contains(a)) return false;
      return a.tagName === 'INPUT' || a.tagName === 'TEXTAREA';
    }
    function layoutGeaendert() {
      if (window.innerWidth === letzteGroesse.w && window.innerHeight === letzteGroesse.h) return false;
      letzteGroesse = { w: window.innerWidth, h: window.innerHeight };
      return true;
    }
    function measureLayout() {
      setHeaderHeight();
      setStageHeight();
    }
    function aufLayoutAenderung() {
      if (tippt()) return;
      if (!layoutGeaendert()) return;
      measureLayout();
      paintPreview();
    }
    measureLayout();
    window.addEventListener('resize', aufLayoutAenderung);
    /* orientationchange feuert vor der neuen Größe — einen Tick warten. */
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        letzteGroesse = { w: 0, h: 0 };
        aufLayoutAenderung();
      }, 250);
    });
    /* visualViewport wird bewusst nur als zusätzlicher Auslöser benutzt und
       durch layoutGeaendert() gefiltert: Tastatur-Events kommen hier nicht
       durch, eine echte Größenänderung schon. */
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', aufLayoutAenderung);
    }
    /* Nach dem Schließen der Tastatur einmal aufräumen — währenddessen war
       jede Neuberechnung gesperrt. */
    root.addEventListener('focusout', function () {
      setTimeout(function () {
        if (tippt()) return;
        /* Nur die Einpassung, nicht die Stage-Höhe. Ein Klick auf eine
           Größen- oder Schriftkarte nimmt dem vorigen Element den Fokus und
           löste hier bisher measureLayout() aus — damit hing eine
           Layout-Eigenschaft an einer Auswahländerung. Die Stage-Höhe darf
           ausschließlich von Viewport und Header abhängen. */
        paintPreview();
      }, 100);
    });

    /* Platz für die Tastatur statt Kampf um die Scrollposition.

       Hier stand vorher ein programmatischer Sprung auf die Stage-Oberkante.
       Am Gerät verlor er gegen Safaris eigenes scroll-into-view: Das Textfeld
       lag nach dem Sprung unter der Tastatur, beim Tippen scrollte Safari
       nach und schob dabei die Wand aus dem Bild, und nach dem Blur stand die
       Seite mitten im Panel. Jede Variante von programmatischem Scrollen
       läuft in dieselbe Konkurrenz.

       Stattdessen wird die klebende Vorschau mobil kleiner, solange ein
       Eingabefeld den Fokus hat: rund 120px statt 204px. Die gewonnenen ~84px
       reichen, damit das Feld über der Tastatur bleibt. Der Schriftzug bleibt
       sichtbar, nur kleiner — die Einpass-Logik rechnet über den
       ResizeObserver auf die reduzierte Wandhöhe. Safari darf danach nativ
       scrollen, wie es will; wir greifen nicht ein. */
    function kompaktSetzen(an) {
      var stage = root.querySelector('.lettra-config__stage');
      if (!stage) return;
      if (stage.classList.contains('is-kompakt') === !!an) return;
      stage.classList.toggle('is-kompakt', !!an);
      /* Sofort neu einpassen und nach der Höhenanimation noch einmal: Der
         ResizeObserver auf der Wand allein genügt nicht als Zusage — er kann
         gedrosselt werden. Der erste Aufruf greift bei abgeschalteter
         Animation (prefers-reduced-motion), der zweite nach dem Übergang. */
      paintPreview();
      var fertig = function (e) {
        if (e && e.propertyName && e.propertyName !== 'height') return;
        stage.removeEventListener('transitionend', fertig);
        paintPreview();
      };
      stage.addEventListener('transitionend', fertig);
      /* Sicherheitsnetz, falls kein transitionend kommt (keine Animation, Tab
         im Hintergrund): nach der Übergangsdauer trotzdem nachrechnen. */
      setTimeout(fertig, 300);
    }
    root.addEventListener('focusin', function (e) {
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) kompaktSetzen(true);
    });
    root.addEventListener('focusout', function () {
      /* Kurz warten: Beim Wechsel von einem Feld ins nächste liegt zwischen
         focusout und focusin ein Moment ohne Fokus — ohne die Verzögerung
         würde die Stage dazwischen aufklappen und wieder zusammenfallen. */
      setTimeout(function () {
        if (!tippt()) kompaktSetzen(false);
      }, 120);
    });

    render();
    /* Nach dem Laden der Displayschrift einmal nachjustieren: Bis dahin wurde
       die Ersatzschrift gemessen, die schmaler baut. */
    if (window.lettraFitAfterFonts) {
      window.lettraFitAfterFonts(function () {
        measureLayout();
        render();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-lettra-config]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
